/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

// Core imports
import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

// Component imports
import { Col, Form, Row, Typography } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import { WebchatUserIcon } from '../../../Icons/WebchatUserIcon';
import { ChatBotIcon } from '../../../Icons/ChatBotIcon';
import AvatarFormFieldSelection from '../../../UI/AvatarFormFieldSelection';
import BotAvatar from '../../../../assets/icons/bot-avatar.png';

// Misc imports
import userHasEditAccess from '../../../../utils/misc/hasEditAccess';
import useTheme from '../../../../utils/hooks/useTheme';

// Constant declarations
const FORM_CONFIGURATION_LAYOUT_PATH = ['settings', 'layout', 'microsoftWebChat', 'configuration'];

const BotDeploymentsWebchatAvatarsForm = ({
  formData = {},
  userRoles = {},
  isCreateMode = false,
  form
}) => {

  const { t } = useTranslation();
  const { formProps } = useTheme();
  const hasEditAccess = isCreateMode ? true : userHasEditAccess(formData?.tenant?.organizationId, userRoles?.organizationRoles, formData?.tenant.id, userRoles?.tenantRoles, true);

  return (
    <Row gutter={formProps.rowGutter}>
      <Col xs={24}>
        <Typography.Text>
          {t('Avatars')}
        </Typography.Text>

        <Typography.Paragraph className="fs-sm" type="secondary">
          {t('Give your agent a distinct personality with special  avatars.')}
        </Typography.Paragraph>
      </Col>

      <Col xs={24}>
        <Form.Item
          label={
            <Typography.Text>
              <ChatBotIcon /> {t('Agent Avatar', { context: 'AI agent' })}
            </Typography.Text>
          }
          name={[...FORM_CONFIGURATION_LAYOUT_PATH, 'botAvatarImage']}
        >
          {
            hasEditAccess ? (
              <AvatarFormFieldSelection
                placeholderImage={<img src={BotAvatar} width="105" alt="webchat preview avatar" />}
                fields={
                  {
                    inputField: null,
                    uploadField: {
                      label: t('Select Image to Upload'),
                      validationMessage: t('Please select or upload an image')
                    }
                  }
                }
              />
            ) : <Typography.Text>{form.getFieldValue([...FORM_CONFIGURATION_LAYOUT_PATH, 'botAvatarImage'])}</Typography.Text>
          }
        </Form.Item>

        <Form.Item
          label={
            <Typography.Text>
              <UserOutlined /> {t('User Avatar')}
            </Typography.Text>
          }
          name={[...FORM_CONFIGURATION_LAYOUT_PATH, 'userAvatarImage']}
        >
          {
            hasEditAccess ? (
              <AvatarFormFieldSelection
                placeholderImage={<WebchatUserIcon />}
                fields={
                  {
                    inputField: null,
                    uploadField: {
                      label: 'Select Image to Upload',
                      validationMessage: 'Please select or upload an image'
                    }
                  }
                }
              />
            ) : <Typography.Text>{form.getFieldValue([...FORM_CONFIGURATION_LAYOUT_PATH, 'userAvatarImage'])}</Typography.Text>
          }
        </Form.Item>
      </Col>
    </Row>
  );
};

BotDeploymentsWebchatAvatarsForm.propTypes = {
  formData: PropTypes.object,
  isCreateMode: PropTypes.bool,
  userRoles: PropTypes.object,
  form: PropTypes.object
};

export default BotDeploymentsWebchatAvatarsForm;
